import React from 'react';
import { GroupDimension, PrimaryGroup } from '../types';
import { SkuTable } from '../SkuTable/SkuTable';
import './VendorGroup.scss';

interface VendorGroupProps {
  group: PrimaryGroup;
  groupDimension: GroupDimension;
  isOpen: boolean;
  onToggle: () => void;
  openSkuRows: Set<string>;
  onToggleSkuRow: (rowKey: string) => void;
  onToggleHold: (holdKey: string) => void;
  onShare: (key: string) => void;
}

export const VendorGroup: React.FC<VendorGroupProps> = ({
  group,
  groupDimension,
  isOpen,
  onToggle,
  openSkuRows,
  onToggleSkuRow,
  onToggleHold,
  onShare,
}) => (
  <div className={`vendor-group ${isOpen ? 'is-open' : ''}`}>
    <div className="vendor-group__head" onClick={onToggle}>
      <span className="vendor-group__caret">▶</span>
      <span className="vendor-group__name">{group.key}</span>
      <span className="vendor-group__meta">
        {group.skuCount} SKU{group.skuCount > 1 ? 's' : ''}
      </span>
      <button
        type="button"
        className="vendor-group__share-btn"
        onClick={(e) => {
          e.stopPropagation();
          onShare(group.key);
        }}
      >
        🔗 Share
      </button>
    </div>

    {isOpen && (
      <SkuTable
        group={group}
        groupDimension={groupDimension}
        openSkuRows={openSkuRows}
        onToggleSkuRow={onToggleSkuRow}
        onToggleHold={onToggleHold}
      />
    )}
  </div>
);
